import { render, staticRenderFns } from "./mySetting.vue?vue&type=template&id=92ea37f0&"
import script from "./mySetting.vue?vue&type=script&lang=js&"
export * from "./mySetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports